import React, { useContext } from "react"
import styled from "styled-components"
import GameContext from "../../../Context/GameContext"
import { PlayerEnergy } from "./PlayerEnergy"
import { createHostAction } from "../createHostAction"
import { actions } from "../../shared/constants"

const Wrap = styled.div`
  display: flex;
  column-gap: 10px;
  grid-column: 2/3;
  padding: 10px 15px 15px 15px;
  background-color: ${props => props.theme.colors?.host_players_background};
  border-radius: 10px;
  border: 1px solid ${props => props.theme.colors?.host_players_border};
  font-size: 14px;
`

const PlayerButtonWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: end;
`

const PlayerWrap = styled.div`
  width: 100px;
  font-size: 14px;
`

const RedistributeButton = styled.div`
  display: flex;
  width: 40px;
  height: 40px;
  background-color: ${props =>
    props.disabled ? "grey" : props.theme.colors.host_button_background};
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 30px;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.75);
  margin: 10px auto auto auto;
  :hover {
    cursor: ${props => (props.disabled ? "not-allowed" : "pointer")};
  }
`

const HostWrap = styled.div`
  width: 120px;
`

const PlayerName = styled.div`
  font-size: 14px;
  text-align: center;
  margin-bottom: 5px;
  margin-top: 10px;
`

export const PlayersRedistribute = props => {
  const { gameState, onAction, gameData } = useContext(GameContext)
  const players = gameState.players
  const host = gameState.host
  const [pending, setPending] = React.useState(false)
  const resource_max = gameData?.game_resource?.max
  const resource_min = gameData?.game_resource?.min

  const handleRedistribute = player => {
    setPending(true)
    onAction(
      createHostAction(actions.HOST_REDISTRIBUTE_TO_PLAYER, {
        playerId: player.id,
      })
    )
    setTimeout(() => {
      setPending(false)
    }, 500)
  }

  return (
    <Wrap>
      {players.map((player, index) => {
        const playerResourceIsMaxed = player.energy.preview >= resource_max
        const hostResourceIsMin = host.energy.preview <= resource_min
        return (
          <PlayerButtonWrap key={index}>
            <RedistributeButton
              onClick={() => handleRedistribute(player)}
              pending={pending}
              disabled={pending || playerResourceIsMaxed || hostResourceIsMin}
              children={"+"}
            />
            <PlayerWrap key={index}>
              <PlayerName>{player.name}</PlayerName>

              <PlayerEnergy player={player} />
            </PlayerWrap>
          </PlayerButtonWrap>
        )
      })}
      <PlayerButtonWrap>
        <HostWrap>
          <PlayerName>{host.name}</PlayerName>

          <PlayerEnergy player={host} isHost={true} />
        </HostWrap>
      </PlayerButtonWrap>
    </Wrap>
  )
}
